// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconLockCheck } from '@tabler/icons-react';
import { AuthLayoutWrapper, PasswordStrength } from '../components';

export default function ResetGradient() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password:', password);
  };

  const passwordsMatch = password === confirmPassword;

  return (
    <AuthLayoutWrapper
      variant="gradient"
      glassEffect
      gradientFrom="#22c55e"
      gradientTo="#10b981"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/reset-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 72,
                height: 72,
                borderRadius: 20,
                background: 'linear-gradient(135deg, #22c55e, #10b981)',
                boxShadow: '0 8px 24px rgba(34, 197, 94, 0.4)',
              }}
            >
              <IconLockCheck size={36} color="white" />
            </Center>
            <Title order={2} ta="center" mt="md">Reset password</Title>
            <Text c="dimmed" size="sm" ta="center" maw={280}>
              Create a new, strong password for your account.
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <div>
              <PasswordInput
                label="New password"
                placeholder="Enter new password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                size="md"
              />
              {password && <PasswordStrength password={password} variant="steps" />}
            </div>

            <PasswordInput
              label="Confirm password"
              placeholder="Confirm new password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              size="md"
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
            />

            <Button
              type="submit"
              fullWidth
              size="md"
              variant="gradient"
              gradient={{ from: '#22c55e', to: '#10b981' }}
              disabled={!passwordsMatch || password.length < 8}
            >
              Save new password
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Button
            component={Link}
            to="/demo/auth-pages/login/gradient"
            variant="subtle"
            leftSection={<IconArrowLeft size={14} />}
          >
            Back to login
          </Button>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
